 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Resources":"Resources","Schedule":"Schedule","Tradeshow":"Tradeshow","attendeeProfile":"attendeeProfile","attendees0":"attendees0","attendees2":"attendees2","attendees4":"attendees4","attendees":"attendees","attendees6":"attendees6","c0":"c0","create-attendee":"create-attendee","create-attendee0":"create-attendee0","create-attendee2":"create-attendee2","create-attendee4":"create-attendee4","sessions":"sessions","create-exhibitor":"create-exhibitor","live-stream0":"live-stream0","live-stream16":"live-stream16","live-stream18":"live-stream18","live-stream2":"live-stream2","live-stream20":"live-stream20","live-stream22":"live-stream22","live-stream24":"live-stream24","live-stream26":"live-stream26","live-stream32":"live-stream32","live-stream34":"live-stream34","live-stream38":"live-stream38","live-stream40":"live-stream40","live-stream42":"live-stream42","live-stream44":"live-stream44","live-stream46":"live-stream46","live-stream48":"live-stream48","live-stream50":"live-stream50","live-stream52":"live-stream52","live-stream54":"live-stream54","live-stream8":"live-stream8","live-stream~meeting~session":"live-stream~meeting~session","live-stream":"live-stream","session":"session","meeting":"meeting","meetingfed":"meetingfed","tradeshow":"tradeshow","tradeshow0":"tradeshow0","tradeshow10":"tradeshow10","tradeshow12":"tradeshow12","tradeshow14":"tradeshow14","tradeshow2":"tradeshow2","tradeshow4":"tradeshow4","tradeshow6":"tradeshow6","tradeshow8":"tradeshow8","transitions":"transitions"}[chunkId]||chunkId) + "." + {"Resources":"4682faf7","Schedule":"c3d57c57","Tradeshow":"cfc24416","attendeeProfile":"cdde3038","attendees0":"04600d46","attendees2":"9500b62d","attendees4":"30934ed8","attendees":"132d8022","attendees6":"924e4489","c0":"28a66418","chunk-5f181376":"f9b669ea","chunk-7ba2fd4a":"fcbcd882","create-attendee":"15f019d9","create-attendee0":"1132ada5","create-attendee2":"efa9b227","create-attendee4":"0f876157","sessions":"67132d92","create-exhibitor":"90eaf496","live-stream0":"a2d0b952","live-stream16":"6d6912f5","live-stream18":"d0deec87","live-stream2":"14aa79bb","live-stream20":"857cb2eb","live-stream22":"6f9db3ef","live-stream24":"eeebbf3f","live-stream26":"eab197d5","live-stream32":"7c604683","live-stream34":"cc6ecaad","live-stream38":"6d34c4f4","live-stream40":"b3440753","live-stream42":"9787affd","live-stream44":"e4a7cb36","live-stream46":"e03d0430","live-stream48":"923c8c2e","live-stream50":"96b799e6","live-stream52":"82f44cbe","live-stream54":"51d978ab","live-stream8":"dad69ca4","live-stream~meeting~session":"7d0ccf8a","live-stream":"e99dce26","session":"e863400a","meeting":"73eb6d25","meetingfed":"df5cccb0","tradeshow":"73aa1853","tradeshow0":"fe8324a8","tradeshow10":"1b126bad","tradeshow12":"f7f9d6ad","tradeshow14":"f7936573","tradeshow2":"8cf602d5","tradeshow4":"eece1548","tradeshow6":"6db4a193","tradeshow8":"8015ea5d","transitions":"cd8f1216","chunk-2d0c7790":"08348c60","chunk-2d0e1811":"1c1b04b2","chunk-2d0f1197":"ea1bbd37","chunk-8bd208ea":"07430de4","chunk-2d5987f9":"5cfc0794","chunk-771a5207":"40de953f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Resources":1,"attendeeProfile":1,"attendees0":1,"attendees4":1,"attendees6":1,"chunk-5f181376":1,"create-attendee":1,"create-attendee0":1,"create-attendee2":1,"create-attendee4":1,"sessions":1,"create-exhibitor":1,"live-stream0":1,"live-stream16":1,"live-stream20":1,"live-stream22":1,"live-stream26":1,"live-stream32":1,"live-stream38":1,"live-stream40":1,"live-stream42":1,"live-stream44":1,"live-stream46":1,"live-stream48":1,"live-stream50":1,"live-stream52":1,"live-stream54":1,"live-stream8":1,"live-stream":1,"meeting":1,"meetingfed":1,"tradeshow":1,"tradeshow12":1,"transitions":1,"chunk-8bd208ea":1,"chunk-2d5987f9":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Resources":"Resources","Schedule":"Schedule","Tradeshow":"Tradeshow","attendeeProfile":"attendeeProfile","attendees0":"attendees0","attendees2":"attendees2","attendees4":"attendees4","attendees":"attendees","attendees6":"attendees6","c0":"c0","create-attendee":"create-attendee","create-attendee0":"create-attendee0","create-attendee2":"create-attendee2","create-attendee4":"create-attendee4","sessions":"sessions","create-exhibitor":"create-exhibitor","live-stream0":"live-stream0","live-stream16":"live-stream16","live-stream18":"live-stream18","live-stream2":"live-stream2","live-stream20":"live-stream20","live-stream22":"live-stream22","live-stream24":"live-stream24","live-stream26":"live-stream26","live-stream32":"live-stream32","live-stream34":"live-stream34","live-stream38":"live-stream38","live-stream40":"live-stream40","live-stream42":"live-stream42","live-stream44":"live-stream44","live-stream46":"live-stream46","live-stream48":"live-stream48","live-stream50":"live-stream50","live-stream52":"live-stream52","live-stream54":"live-stream54","live-stream8":"live-stream8","live-stream~meeting~session":"live-stream~meeting~session","live-stream":"live-stream","session":"session","meeting":"meeting","meetingfed":"meetingfed","tradeshow":"tradeshow","tradeshow0":"tradeshow0","tradeshow10":"tradeshow10","tradeshow12":"tradeshow12","tradeshow14":"tradeshow14","tradeshow2":"tradeshow2","tradeshow4":"tradeshow4","tradeshow6":"tradeshow6","tradeshow8":"tradeshow8","transitions":"transitions"}[chunkId]||chunkId) + "." + {"Resources":"925e6cf8","Schedule":"31d6cfe0","Tradeshow":"31d6cfe0","attendeeProfile":"ba6e9c2b","attendees0":"c5b90a85","attendees2":"31d6cfe0","attendees4":"c5b90a85","attendees":"31d6cfe0","attendees6":"c5b90a85","c0":"31d6cfe0","chunk-5f181376":"c5b90a85","chunk-7ba2fd4a":"31d6cfe0","create-attendee":"7c9594b7","create-attendee0":"c7b9992b","create-attendee2":"c7b9992b","create-attendee4":"0a9f1d1c","sessions":"9b8413ec","create-exhibitor":"5c0a4ec8","live-stream0":"5c0a4ec8","live-stream16":"dc4e7911","live-stream18":"31d6cfe0","live-stream2":"31d6cfe0","live-stream20":"aee6d127","live-stream22":"bdd3fc39","live-stream24":"31d6cfe0","live-stream26":"925e6cf8","live-stream32":"818f3fda","live-stream34":"31d6cfe0","live-stream38":"cf989231","live-stream40":"8f8c1b6d","live-stream42":"b5667b36","live-stream44":"802174f5","live-stream46":"8bb26278","live-stream48":"9ffc03fb","live-stream50":"38d68345","live-stream52":"fa16f21a","live-stream54":"045706c6","live-stream8":"7c9594b7","live-stream~meeting~session":"31d6cfe0","live-stream":"3edc9d36","session":"31d6cfe0","meeting":"720b1ed8","meetingfed":"ad076c3a","tradeshow":"fb48436d","tradeshow0":"31d6cfe0","tradeshow10":"31d6cfe0","tradeshow12":"24c74e5a","tradeshow14":"31d6cfe0","tradeshow2":"31d6cfe0","tradeshow4":"31d6cfe0","tradeshow6":"31d6cfe0","tradeshow8":"31d6cfe0","transitions":"e5b5e687","chunk-2d0c7790":"31d6cfe0","chunk-2d0e1811":"31d6cfe0","chunk-2d0f1197":"31d6cfe0","chunk-8bd208ea":"60968acb","chunk-2d5987f9":"c5b90a85","chunk-771a5207":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([1,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
